<template>
  <div class="calendar-picker">
    <span
      class="ibass ibass-arrow-left"
      @click="setPrev"
    ></span>
    <div class="calendar-picker-ctrl">
      <span class="calendar-picker-text">{{ dateValueText }}</span>
      <el-date-picker
        v-model="dateValue"
        :type="dateType"
        :picker-options="pickerOptions"
        :editable="false"
        @change="changeDate"
      />
    </div>
    <span
      class="ibass ibass-arrow-right"
      @click="setNext"
    ></span>
  </div>
</template>
<script>
export default {
  name: 'CalendarPicker',
  props: {
    viewType: String,
    date: String
  },
  data () {
    return {
      dateValue: this.date,
      dateValueText: '',
      pickerOptions: {
        firstDayOfWeek: 1
      },
      labelAdaptor: {
        YEAR (date) {
          return moment(date, 'YYYY-MM-DD').format('YYYY年')
        },
        MONTH (date) {
          return moment(date, 'YYYY-MM-DD').format('YYYY年MM月')
        },
        WEEK (date) {
          const _date = moment(date, 'YYYY-MM-DD').startOf('week')
          return `${_date.format('YYYY年MM月DD日')}-${_date.add(6, 'day').format('MM月DD日')}`
        },
        DAYS (date) {
          return moment(date, 'YYYY-MM-DD').format('YYYY年MM月DD日')
        }
      }
    }
  },
  computed: {
    dateType () {
      if (['days', 'week'].includes(this.viewType) || !this.viewType) {
        return 'date'
      }
      return this.viewType
    }
  },
  watch: {
    viewType (val) {
      this.getLabel(val)
    },
    date (val) {
      this.dateValue = val
      this.getLabel(this.viewType)
    }
  },
  created () {
    this.getLabel(this.viewType)
  },
  methods: {
    getWeekRange (value) {
      let day = value.getDay()
      let begin = moment(value).subtract(day - 1, 'days')
      let end = moment(value).add(7 - day, 'days')
      if (begin.format('YYYY') !== end.format('YYYY')) {
        end = end.format('YYYY年MM月DD日')
      } else {
        end = end.format('MM月DD日')
      }
      return [begin.format('YYYY年MM月DD日'), end].join(' - ')
    },
    changeDate (value) {
      this.dateValue = value
      this.updateDate()
    },
    updateDate () {
      this.getLabel(this.viewType)
      this.$emit('click', this.dateValue)
    },
    getLabel (type = 'week') {
      type = type.toUpperCase()
      this.dateValueText = this.labelAdaptor[type](this.dateValue)
    },
    updateLabel () {
      this.getLabel(this.viewType)
      this.$emit('click', this.dateValue)
    },
    setPrev () {
      this.dateValue = moment(this.dateValue, 'YYYY-MM-DD').subtract(1, this.viewType).format('YYYY-MM-DD')
      this.updateLabel()
    },
    setNext () {
      this.dateValue = moment(this.dateValue, 'YYYY-MM-DD').add(1, this.viewType).format('YYYY-MM-DD')
      this.updateLabel()
    }
  }
}
</script>
<style lang="stylus">
.calendar-picker
  display flex
  justify-content space-between
  flex-wrap nowrap
  align-items center
  &-ctrl
    position relative
    margin 0 8px
    .el-date-editor.el-input,
    .el-input__inner
      width 100%
      padding 0
    .el-input__inner
      height auto
      line-height 1
      cursor pointer
    .el-input__prefix,
    .el-input__suffix
      display none
  .el-date-editor
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    text-align center
    color #000
    cursor pointer
    white-space nowrap
    user-select none
    opacity 0
    cursor pointer
  .ibass
    position relative
    top 2px
    color #a8a8a9
    cursor pointer
</style>
